import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { coverageAreas, artistData } from '../data/mock';

const CoverageSection = () => {
  return (
    <section id="coverage" className="py-24 bg-stone-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={artistData.images.barn}
          alt="Midwest Americana"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900 via-stone-900/95 to-stone-900" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gold-500/10 border border-gold-500/20 rounded-full px-4 py-2 mb-6">
            <Navigation className="w-4 h-4 text-gold-400" />
            <span className="text-gold-300 text-sm font-medium">Service Area</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Touring the <span className="text-gold-400">Midwest</span>
          </h2>
          <p className="text-stone-400 text-lg max-w-2xl mx-auto">
            Based in Omaha, Nebraska, bringing authentic country music to venues across 8 states and counting.
          </p>
        </div>

        {/* States Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-4xl mx-auto mb-12">
          {coverageAreas.map((area, index) => (
            <div
              key={index}
              className={`relative group bg-stone-950/50 border rounded-2xl p-6 text-center transition-all duration-300 hover:-translate-y-1 ${
                area.isBase
                  ? 'border-gold-500/50 bg-gold-500/10'
                  : 'border-stone-800 hover:border-gold-500/30'
              }`}
            >
              {area.isBase && (
                <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  HOME BASE
                </div>
              )}
              <div className="flex items-center justify-center gap-2 mb-2">
                <MapPin className={`w-5 h-5 ${area.isBase ? 'text-gold-400' : 'text-stone-500 group-hover:text-gold-400'} transition-colors`} />
              </div>
              <p className="text-2xl font-bold text-white mb-1">{area.abbr}</p>
              <p className="text-stone-400 text-sm">{area.state}</p>
            </div>
          ))}
        </div>

        {/* Note */}
        <div className="text-center">
          <div className="inline-block bg-stone-950/50 border border-stone-800 rounded-xl px-8 py-4">
            <p className="text-stone-300">
              <span className="text-gold-400 font-semibold">Don't see your state?</span>
              <br />
              <span className="text-stone-400">Drop us a line and let's talk details!</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverageSection;
